import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=ee0f41e8&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/page_style/contact.scss?vue&type=style&index=0&id=ee0f41e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0f41e8",
  null
  
)

export default component.exports